import { Injectable } from '@angular/core';
import { ValidatorFn, FormGroup, ValidationErrors, FormArray, FormControl, AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class RosterValidatorService {

  constructor() { }
  rosterValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      const errors: ValidationErrors = {};
      let roster = control as FormArray
      if (!roster) {
        errors.rosterError = {
          message: 'No records in roster'
        };
      }
      else if (!roster.length) {
        errors.rosterError = {
          message: 'No records in roster'
        };
      }
      else {
        let isSelected = false;
        for (let ct = 0; ct < roster.length; ct++) {
          if (roster.at(ct).get("isSelected").value) {
            isSelected = true;
            return;
          }
        }
        if (!isSelected && control.parent.get("NewContacts").value.length === 0 )
          errors.rosterError = {
            message: 'You must select at least one record'
          };
      }
      return Object.keys(errors).length ? errors : null;
    };
  }

  formValidator(): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      const errors: ValidationErrors = {};

      if (!(control.get('Roster') as FormArray).length) {
        errors.rosterError = {
          message: 'No records in roster'
        };

        control.get('Roster').setErrors(errors);
      }
       else if (control instanceof FormArray && (control as FormArray).length > 0) {
        control.markAsTouched({ onlySelf: true });
        let isSelected = false;
        for (let ct = 0; ct < control.length; ct++) {
          if (control.at(ct).get("isSelected").value) {
            isSelected = true;
            return;
          }
        }
        // if (!isSelected)
        //   errors.rosterError = { message: "Must select a record" };
        control.setErrors(errors);
      }

      return Object.keys(errors).length ? errors : null;
    };
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);

      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
      else if (control instanceof FormArray) {
        control.markAsTouched({ onlySelf: true });
        let isSelected = false;
        for (let ct = 0; ct < control.length; ct++) {
          if (control.at(ct).get("isSelected").value) {
            isSelected = true;
            return;
          }
        }
        // if (!isSelected)
        //   control.setErrors({ rosterError: "Must select a record" });
      }
    });
  }

  rosterItemValidator(): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      const errors: ValidationErrors = [];

      // const pizzaSize: PizzaSizeEnum = control.get('size').value;
      // const pizzaToppings: IToppingItem[] = control.get('toppings').value.filter(i => i.selected);

      // if (pizzaSize !== PizzaSizeEnum.LARGE && pizzaToppings.length > 4) {
      //   errors.toppingPizzaSize = {
      //     message: 'To use more then 4 toppings you must selected large pizza'
      //   };
      // }

      return Object.keys(errors).length ? errors : null;
    };
  }
}
